import { useQuery } from '@tanstack/react-query';
import React,{ createContext,useCallback,useEffect,useMemo,useRef,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { allFuncionalities } from '../components/Settings/utils/arrayFuncionalities';
import { userBackObj } from '../components/Users/ListaUsuarios';
import AttToken from '../helpers/attToken';
import IUserData,{ Profiles } from '../interface/IUserData';
import Companies from '../service/Companies';
import { ChecklistType } from '../types/checklist/types';
import { chamadoToSend } from '../types/new-form-filling/types';
import { TicketsType } from '../types/notifications/types';
import { PlaceType } from '../types/places/types';
import { analisePendenteType } from '../types/plano-de-acao/types';
import { FormType,InitialFormItem,initialPrintTemplate } from '../types/print-template/types';
import { types } from '../types/services/types';
import { team } from '../types/teams/types';
import type { HierarchyLabel } from '../types/hierarchy';
import type { SessionIdentity } from '../types/auth';
import IUserStore from './interfaces/IUserStore';
import {
  clearPersistedUserSessionData,
  readHierarchyCache,
  readUserDataCache,
  writeHierarchyCache,
  writeUserDataCache,
} from '../service/userSessionCache';


export const identifierTypesList = ['textoCurto', 'telefone', 'rg', 'cpfcnpj', 'cep', 'placa'];

const initialTeam = {
  dataAlteracao: 0,
  dataCadastro: 0,
  empresa: '',
  gerente: '',
  listaCliente: [],
  nome: '',
  status: false,
  users: [''],
  teamID: ''
};

const initialContact = {
  id: 0,
  name: "",
  phone: "",
  email: "",
};

const initialHierarchy = {
  cliente: 'Cliente',
  local: 'Local',
  conjunto: 'Conjunto',
  unidade: 'Unidade',
  gerencia: 'Gerência'
};

const initialEditing = {
  editing: false,
  id: ''
};

export type editingType = {
  editing: boolean,
  id: string,
};

export type identifiersByForm = {
  formId: string,
  identifiersList: { value: string, nome: string }[];
};

const initalState = {
  userData: {
    companyName: '',
    email: '',
    listaFuncionalidades: [''],
    notificacao: '',
    profilePhoto: '',
    role: 'Usuario' as Profiles,
    userName: '',
    aprovador: false,
    migrado: false,
    gestorPA: false,
    inspetorPA: false,
    formMigrado: false,
    concedeAcesso: false,
    phone: '',
    matricula: '',
    assinatura: '',
    id: '',
    gerenciaMigrada: false,
  },

  firebaseToken: '',
  setFirebaseToken: () => { },
  saveUserData: () => { },
  loadCachedUserData: () => null,
  setSessionIdentity: () => { },
  clearUserSessionData: () => { },
  escape: () => { },
  isHidden: false,
  setIsHidden: () => { },
  teamList: [initialTeam],
  setTeamList: () => { },
  userList: undefined,
  setUserList: () => { },
  openModal: () => { },
  popUp: false,
  setPopUp: () => { },
  userTags: [],
  setUserTags: () => { },
  funcionalitiesList: allFuncionalities,
  setFuncionalitiesList: () => { },
  hierarchyLabel: initialHierarchy,
  setHierarchyLabel: () => { },
  saveHierarchyLabel: () => { },
  loadCachedHierarchyLabel: () => null,
  customerTags: [['']],
  setCustomerTags: () => { },
  addContact: [initialContact],
  setAddContact: () => { },
  formList: [InitialFormItem],
  setFormList: () => { },
  secondaryPopUp: false,
  openSecondaryModal: () => { },
  selectedForm: 0,
  setSelectedForm: () => { },
  printTemplateList: [initialPrintTemplate],
  setPrintTemplateList: () => { },
  serviceTypesList: [],
  setServiceTypesList: () => { },
  checklistClone: '',
  setChecklistClone: () => { },
  customerId: '',
  setCustomerId: () => { },
  loadingClick: false,
  setLoadingClick: () => { },
  ticket: undefined,
  setTicket: () => { },
  show: false,
  setShow: () => { },
  expanded: false,
  setExpanded: () => { },
  editing: initialEditing,
  setEditing: () => { },
  changed: false,
  setChanged: () => { },
  placesList: undefined,
  setPlacesList: () => { },
  editPlace: undefined,
  setEditPlace: () => { },
  isEditing: false,
  setIsEditing: () => { },
  totalAnalises: 0,
  setTotalAnalises: () => { },
  analisesPendentes: [] as analisePendenteType[],
  setAnalisesPendentes: () => { },
  loadingAnalises: true,
  setLoadingAnalises: () => { },
  pageNumber: 0,
  setPageNumber: () => { },
  itensPerPage: 10,
  setItensPerPage: () => { },
  totalItens: 10,
  setTotalItens: () => { },
  setInitialIdentifiers: (formList: ChecklistType[]) => { },
  identifiersByForm: [] as identifiersByForm[],
  setIdentifiersByForm: () => { },
  acessoPlanoDeAcao: false,
  setUserData: () => { },
  logado: null,
  setLogado: () => { },
  chamadosArray: [],
  setChamadosArray: () => { },
  selectedCliente: null,
  setSelectedCliente: () => { },
  selectedLocal: null,
  setSelectedLocal: () => { },
  selectedConjunto: null,
  setSelectedConjunto: () => { },
  selectedUnidade: null,
  setSelectedUnidade: () => { },
  loadingFuncionalities: true,
  setLoadingFuncionalities: () => { }
};

export const UserContext = createContext<IUserStore>(initalState);
export default function UserProvider({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation('translation');

  const companyService = useMemo(() => new Companies(), []);

  const [userData, setUserData] = useState<IUserData>(initalState.userData);
  const [isHidden, setIsHidden] = useState(false);
  const [teamList, setTeamList] = useState<team[]>([initialTeam]);
  const [userList, setUserList] = useState<userBackObj[]>();
  const [funcionalitiesList, setFuncionalitiesList] = useState(allFuncionalities);
  const [popUp, setPopUp] = useState(false);
  const [secondaryPopUp, setSecondaryPopUp] = useState(false);
  const [userTags, setUserTags] = useState([]);
  const [customerTags, setCustomerTags] = useState([['']]);
  const [firebaseToken, setFirebaseToken] = useState('');
  const [expanded, setExpanded] = useState<string | false>(false);
  const [hierarchyLabel, setHierarchyLabel] = useState({
    cliente: t('settingsPage.hierarchy.client'),
    local: t('settingsPage.hierarchy.place'),
    conjunto: t('settingsPage.hierarchy.set'),
    unidade: t('settingsPage.hierarchy.unity'),
    gerencia: t('Reports.columns.manegement'),
  });

  const [addContact, setAddContact] = useState([initialContact]);
  const [formList, setFormList] = useState<FormType[]>([InitialFormItem]);
  const [selectedForm, setSelectedForm] = useState(0);
  const [printTemplateList, setPrintTemplateList] = useState([initialPrintTemplate]);
  const [serviceTypesList, setServiceTypesList] = useState<types[]>([]);
  const [checklistClone, setChecklistClone] = useState<string>('');
  const [customerId, setCustomerId] = useState('');
  const [loadingClick, setLoadingClick] = useState(false);
  const [ticket, setTicket] = useState<TicketsType| undefined>(undefined);
  const [show, setShow] = useState(false);
  const [editing, setEditing] = useState<editingType>(initialEditing);
  const [changed, setChangedState] = useState(false);
  const sessionIdentityRef = useRef<SessionIdentity | null>(null);
  const [placesList, setPlacesList] = useState<PlaceType[]>([]);
  const [editPlace, setEditPlace] = useState<PlaceType | undefined>(undefined);
  const [isEditing, setIsEditing] = useState(false);
  const [totalAnalises, setTotalAnalises] = useState<number>(0);
  const [analisesPendentes, setAnalisesPendentes] = useState<analisePendenteType[]>([] as analisePendenteType[]);
  const [loadingAnalises, setLoadingAnalises] = useState<boolean>(true);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [itensPerPage, setItensPerPage] = useState<number>(10);
  const [totalItens, setTotalItens] = useState<number>(10);
  const [identifiersByForm, setIdentifiersByForm] = useState<identifiersByForm[]>([]);
  const [logado, setLogado] = useState<boolean | null>(null);
  const [chamadosArray, setChamadosArray] = useState<{ [key: string]: chamadoToSend[] }[] | []>([]);
  const [selectedCliente, setSelectedCliente] = useState<{ nome: string, id: string } | null>(null);
  const [selectedLocal, setSelectedLocal] = useState<{ nome: string, id: string } | null>(null);
  const [selectedConjunto, setSelectedConjunto] = useState<{ nome: string, id: string } | null>(null);
  const [selectedUnidade, setSelectedUnidade] = useState<{ nome: string, id: string } | null>(null);
  const [loadingFuncionalities, setLoadingFuncionalities] = useState(true);

  const setInitialIdentifiers = (formList: ChecklistType[]) => {

    const list: identifiersByForm[] = [];
    Object.values(formList ?? {})?.forEach(form => {
      const identifiersList: { nome: string, value: string }[] = [];
      form.itens.forEach((item, itemIndex) => {
        item.subitens.forEach((sub, subIndex) => {
          if (identifierTypesList.includes(sub.tipo)) {
            identifiersList.push({ value: `${form.id}|${form.versao}|${itemIndex}|${subIndex}`, nome: sub.nome });
          }
        });
      });
      list.push({
        formId: form.id,
        identifiersList
      });
    });
    setIdentifiersByForm(list);
  };

  const saveUserData = useCallback((data: IUserData) => {
    const identity = sessionIdentityRef.current;
    if (identity) writeUserDataCache(identity, data);
    setUserData(data);
  }, []);

  const loadCachedUserData = useCallback(readUserDataCache, []);

  const loadCachedHierarchyLabel = useCallback(readHierarchyCache, []);

  const saveHierarchyLabel = useCallback((data: HierarchyLabel) => {
    const identity = sessionIdentityRef.current;
    if (identity) writeHierarchyCache(identity.empresaId, data);
    setHierarchyLabel(data);
  }, []);

  const setSessionIdentity = useCallback((identity: SessionIdentity | null) => {
    sessionIdentityRef.current = identity;

    if (!identity) {
      setChangedState(false);
      return;
    }

    const scopedKey = `changedHirarquia:${encodeURIComponent(identity.empresaId)}`;
    const readBoolean = (value: string | null) => {
      if (value === 'true') return true;
      if (value === 'false') return false;
      return null;
    };

    let storedChange: boolean | null = null;
    try {
      storedChange = readBoolean(localStorage.getItem(scopedKey));
      if (storedChange === null) {
        const legacyChange = readBoolean(localStorage.getItem('changedHirarquia'));
        if (legacyChange !== null) {
          storedChange = legacyChange;
          localStorage.setItem(scopedKey, String(legacyChange));
          localStorage.removeItem('changedHirarquia');
        }
      }
    } catch {
      storedChange = null;
    }

    setChangedState(storedChange ?? false);
  }, []);

  const setChanged = useCallback((value: boolean) => {
    setChangedState(value);
    const identity = sessionIdentityRef.current;
    if (!identity) return;

    try {
      localStorage.setItem(
        `changedHirarquia:${encodeURIComponent(identity.empresaId)}`,
        String(value),
      );
    } catch {
      // The in-memory flag still works if browser storage is unavailable.
    }
  }, []);

  const clearUserSessionData = useCallback(() => {
    clearPersistedUserSessionData();
    sessionIdentityRef.current = null;
    setUserData(initalState.userData);
    setHierarchyLabel({
      cliente: t('settingsPage.hierarchy.client'),
      local: t('settingsPage.hierarchy.place'),
      conjunto: t('settingsPage.hierarchy.set'),
      unidade: t('settingsPage.hierarchy.unity'),
      gerencia: t('Reports.columns.manegement'),
    });
    setFirebaseToken('');
    setChangedState(false);
  }, [t]);

  const openModal = useCallback(() => {
    setPopUp(!popUp);
  }, [popUp]);

  const openSecondaryModal = () => {
    setSecondaryPopUp(!secondaryPopUp);
  };

  const escape = useCallback((e: KeyboardEvent): void => {
    if (e.key === 'Escape' && popUp) {
      openModal();
      setIsEditing(false);
    }
  }, [openModal, popUp]);

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
  }, [escape]);

  const { data } = useQuery({
    queryKey: ['CHECA_ACESSO_PLANO', userData],
    queryFn: async () => {
      if (window.location.pathname.split('/')[1] !== 'preenchedor') {
        const token = await AttToken();
        if (token) {
          const res: { acesso: boolean } = await companyService.checaAcessoPlanoDeAcao(token);
          return res.acesso;
        }
      } else {
        return false;
      }
    },
    enabled: userData.concedeAcesso ?? false,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchInterval: 5 * 60 * 1000,
  });

  const store = {
    loadingFuncionalities,
    setLoadingFuncionalities,
    selectedCliente,
    setSelectedCliente,
    selectedLocal,
    setSelectedLocal,
    selectedConjunto,
    setSelectedConjunto,
    selectedUnidade,
    setSelectedUnidade,
    chamadosArray,
    setChamadosArray,
    logado,
    setLogado,
    pageNumber,
    setPageNumber,
    itensPerPage,
    setItensPerPage,
    totalItens,
    setTotalItens,
    analisesPendentes,
    setAnalisesPendentes,
    totalAnalises,
    setTotalAnalises,
    show,
    setShow,
    ticket,
    setTicket,
    firebaseToken,
    setFirebaseToken,
    loadingClick,
    setLoadingClick,
    customerId,
    setCustomerId,
    serviceTypesList,
    setServiceTypesList,
    userData,
    setUserData,
    saveUserData,
    loadCachedUserData,
    setSessionIdentity,
    clearUserSessionData,
    isHidden,
    setIsHidden,
    teamList,
    setTeamList,
    userList,
    setUserList,
    popUp,
    setPopUp,
    openModal,
    escape,
    userTags,
    setUserTags,
    funcionalitiesList,
    setFuncionalitiesList,
    hierarchyLabel,
    setHierarchyLabel,
    saveHierarchyLabel,
    loadCachedHierarchyLabel,
    customerTags,
    setCustomerTags,
    addContact,
    setAddContact,
    formList,
    setFormList,
    secondaryPopUp,
    openSecondaryModal,
    selectedForm,
    setSelectedForm,
    printTemplateList,
    setPrintTemplateList,
    checklistClone,
    setChecklistClone,
    expanded,
    setExpanded,
    editing,
    setEditing,
    changed,
    setChanged,
    placesList,
    setPlacesList,
    editPlace,
    setEditPlace,
    isEditing,
    setIsEditing,
    loadingAnalises,
    setLoadingAnalises,
    identifiersByForm,
    setIdentifiersByForm,
    setInitialIdentifiers,
    acessoPlanoDeAcao: data as boolean,
  };

  return (
    <UserContext.Provider value={store}>
      {children}
    </UserContext.Provider>
  );
}
